import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SidebarState = {
  dataSidebar: SidebarType;
  activeContextType: string | null;
};

export const sidebarInitialState: SidebarState = {
  dataSidebar: {
    navigation: [],
  },
  activeContextType: null,
};

export const slice = createSlice({
  name: 'sidebar',
  initialState: sidebarInitialState,
  reducers: {
    setListSidebarAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: SidebarType;
      }>,
    ) {
      state.dataSidebar = payload.data;
      state.activeContextType = payload.data.activeContextType || null;
    },
  },
});

export const { setListSidebarAction } = slice.actions;

export default slice.reducer;
